<template>
  <div class="page posts-page">
    <transition name="opacity">
      <div class="write-modal" v-if="creatingPost">
        <div>
          <button class="close" @click="creatingPost = false">
            <i class="fas fa-times"></i>
          </button>
          <h3>{{ appVocubulary.createPost }}</h3>
          <textarea
            v-model="newPost.text"
            @input="adjustDirection($event)"
          ></textarea>
          <div>
            <label for="newPost-topic">{{ appVocubulary.topicQuestion }}</label>
            <span>{{ appVocubulary.topicNote }}</span>
            <select id="newPost-topic" v-model="newPost.topic">
              <option
                v-for="(interest, key) in interestsVocubulary_newpost"
                :value="key"
                :key="interest"
              >
                {{ interest }}
              </option>
            </select>
          </div>
          <div>
            <input type="checkbox" id="my-name" v-model="newPost.showName" />
            <label for="my-name">{{ appVocubulary.showName }}</label>
          </div>
          <button @click="publishPost()">{{ appVocubulary.post }}</button>
        </div>
      </div>
    </transition>
    <div class="container">
      <div>
        <button
          class="create-toggle"
          @click="creatingPost = true"
          v-if="loggedIn"
        >
          {{ appVocubulary.createPost }}
        </button>
        <select id="filter" v-model="topicWanted">
          <option
            v-for="(interest, key) in interestsVocubulary_filter"
            :value="key"
            :key="interest"
          >
            {{ interest }}
          </option>
        </select>
      </div>
      <div v-if="posts.length === 0" id="loading-placeholder">
        <span v-if="noPosts">{{ appVocubulary.noPosts }}</span>
        <i v-else class="fas fa-circle-notch fa-2x fa-spin"></i>
      </div>

      <w-post
        v-for="post in posts"
        :key="post._id"
        :postData="JSON.stringify(post)"
        @shrink="currentPostId = undefined"
        @expand="currentPostId = post._id"
        @fetch-posts="getPosts"
        @reply-to="setReply"
        @change-topic="changeTopic"
        :ref="'popup-' + post._id"
      >
      </w-post>
      <transition name="from-bottom">
        <w-input
          v-if="currentPostId && loggedIn"
          :reply="replyText[1]"
          @send-content="addComment()"
          @no-reply="replyText = ''"
        >
          <textarea
            id="chat-textarea"
            v-model="typedComment"
            @input="adjustDirection($event)"
          ></textarea>
        </w-input>
      </transition>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import WInput from "../components/WInput.vue";
import WPost from "../components/WPost";

export default {
  name: "Posts",
  components: { WInput, WPost },
  data() {
    return {
      newPost: {
        author: [],
        text: "",
        topic: "question",
        showName: true,
      },
      creatingPost: false,
      currentPostId: "",
      posts: [],
      typedComment: "",
      replyText: "",
      noPosts: false,
      loggedIn: false,
      topicWanted: "everything",
    };
  },
  watch: {
    topicWanted(newTopic) {
      this.getPosts(newTopic);
    },
    currentPostId(newId) {
      if (location.href.includes("?id=")) {
        location.href = location.href.substring(
          location.href.indexOf("?id="),
          -1
        );
      }
      if (newId && newId !== "") {
        document.getElementById(newId).classList.add("expanded-post");
        document.getElementById(newId).classList.remove("shrinked-post");
        location.href = `${location.href}?id=${newId}`;
      } else {
        document.querySelector(".expanded-post").classList.add("shrinked-post");
        document
          .querySelector(".expanded-post")
          .classList.remove("expanded-post");
      }
    },
  },
  computed: {
    thisUser() {
      return this.$store.state.user;
    },
    lang() {
      return this.$store.state.lang;
    },
    appVocubulary() {
      return this.$store.state.appVocubulary[this.lang].pages.Posts;
    },
    interestsVocubulary_filter() {
      return this.$store.state.appVocubulary[this.lang].public.interests;
    },
    interestsVocubulary_newpost() {
      let interests = {
        ...this.$store.state.appVocubulary[this.lang].public.interests,
      };
      delete interests.everything;
      if (!this.thisUser.isAdmin) {
        delete interests.announce;
      }
      return interests;
    },
  },
  async mounted() {
    if (this.thisUser.name !== "") {
      this.loggedIn = true;
    }
    await this.getPosts();
    if (location.href.includes("?id=")) {
      this.currentPostId = location.href.slice(location.href.indexOf("=") + 1);
      setTimeout(() => {
        document.querySelector(".expanded-post .comments").click();
      }, 2000);
    }
  },
  methods: {
    // custom events handelers :
    setReply(replyText) {
      this.replyText = replyText;
    },
    changeTopic(newTopic) {
      this.topicWanted = newTopic;
    },
    // general :
    adjustDirection(e) {
      let ar = /[\u0621-\u064A]/;
      if (ar.test(e.currentTarget.value[0])) {
        e.currentTarget.dir = "rtl";
      } else {
        e.currentTarget.dir = "ltr";
      }
    },

    expandPost(id, decision) {
      if (decision) {
        this.currentPostId = id;
      } else {
        this.currentPostId = undefined;
      }
    },

    // posts functions :

    async getPosts(topic) {
      let fetchedPosts;
      if (!topic || topic === "everything") {
        fetchedPosts = await axios.get(
          `${this.$store.state.backend_link}posts/`
        );
      } else {
        fetchedPosts = await axios.get(
          `${this.$store.state.backend_link}posts/categories/${topic}`
        );
      }
      this.posts = fetchedPosts.data;
      if (fetchedPosts.data.length === 0) this.noPosts = true;
    },
    async refreshPost(postId) {
      const wanted = await axios.get(
        `${this.$store.state.backend_link}posts/${postId}`
      );
      this.posts.splice(
        this.posts.findIndex((u) => u._id === this.currentPostId),
        1,
        wanted.data
      );
    },
    async publishPost() {
      if (this.newPost.showName) {
        this.newPost.author = [
          this.thisUser.name,
          this.thisUser._id,
          this.thisUser.details.gender,
        ];
        if (this.thisUser.isAdmin) this.newPost.author.push("Admin");
      } else {
        this.newPost.author = ["Some Member", this.thisUser._id, "unknown"];
      }
      console.log(this.newPost);
      await axios.post(
        `${this.$store.state.backend_link}posts/add`,
        this.newPost
      );
      this.creatingPost = false;
      this.newPost.text = "";
      this.topicWanted = this.newPost.topic;
    },

    // comments :
    async addComment() {
      if (this.typedComment.trim() === "") return;
      const newComment = {
        author: [
          this.thisUser.name,
          this.thisUser._id,
          this.thisUser.details.gender,
        ],
        text: this.typedComment,
      };
      if (this.thisUser.isAdmin) newComment.author.push("Admin");
      if (this.replyText !== "") {
        await axios.post(
          `${this.$store.state.backend_link}comments/reply/${this.replyText[0]}`,
          newComment
        );
      } else {
        newComment.onPost = this.currentPostId;
        await axios.post(
          `${this.$store.state.backend_link}comments/${this.currentPostId}`,
          newComment
        );
      }
      this.typedComment = "";
      this.replyText = "";
      this.$refs[`popup-${this.currentPostId}`].refreshPost();
    },
  },
};
</script>

<style lang="scss" scoped>
html[lang="en"] {
  .container {
    text-align: left;
    .likes-comments {
      transform: translateX(-10px);
    }
  }
}
html[lang="ar"] {
  .container {
    text-align: right;
    .likes-comments {
      transform: translateX(10px);
    }
  }
}

.posts-page {
  position: relative;
}

.container {
  & > div:not(#loading-placeholder) {
    display: flex;
    justify-content: space-around;
    height: 80px;
    padding: 20px 0;
    & > * {
      margin: 0;
    }
    #filter {
      width: fit-content;
      border-radius: 40px;
      background-color: transparent;
      border: 2px solid var(--accent);
      color: var(--text);
      padding: 0 10px;
      option {
        color: var(--text);
      }
    }
  }
}
.write-modal {
  z-index: 6;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: var(--tent-strong);
  display: flex;
  justify-content: center;
  align-items: center;
  & > div {
    position: relative;
    width: 80%;
    max-width: 800px;
    background-color: var(--bg2);
    border-radius: 10px;
    padding: 20px;

    label[for="newPost-topic"] + span {
      color: var(--accent);
      display: block;
      font-size: 0.8em;
      margin: 10px 0;
    }

    .close {
      position: absolute;
      top: 14px;
      left: 14px;
    }
    & > div {
      margin: 10px 0;
    }
    textarea {
      background-color: var(--bg);
      color: var(--text);
      width: 100%;
      height: 100px;
      padding: 6px 10px;
      border-radius: 4px;
      outline: none;
      border: none;
      resize: none;
      overflow: auto;
    }
  }
}
#loading-placeholder {
  text-align: center;
  padding: 30px 0;
  .fa-circle-notch {
    width: fit-content;
    padding: 0;
    margin: 0 auto;
  }
}
</style>
